import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'ru',
    fullName: 'Russian',
    nativeName: 'Русский',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "АргВоид",
    landing_title: "Грядет что-то удивительное",
    landing_subtitle: "ArgVoid — студия разработки приложений и игр. Оставайтесь с нами, скоро будет что-то новое!",
    select_language: "Выберите язык",
    search_placeholder: "Поиск языков...",
    terms_title: "Условия использования",
    policy_title: "политика конфиденциальности",
    cookies_title: "Политика использования файлов cookie",
    terms_content: `
        Х0Х1. Принятие условий</strong><br>
        Получая доступ к ArgVoid, вы принимаете настоящие Условия обслуживания. Если эти условия не согласованы, услугу использовать нельзя.<br><br>

        Х5Х2. Использование платформы</strong><br>
        ArgVoid и его приложения предоставляются «как есть» для информационных и творческих целей. Сервис должен использоваться только в законных целях.<br><br>

        Х10Х3. Запрещенное поведение</strong><br>
        Эксплуатация уязвимостей сайта, рассылка спама или попытки несанкционированного доступа к инфраструктуре строго запрещены.<br><br>

        Х15Х4. Отказ от ответственности</strong><br>
        Платформа и услуги могут быть изменены в любое время без предварительного уведомления. Никаких гарантий относительно бесперебойной работы или доступности услуги не предоставляется.
    `,
    policy_content: `
        Х0Х1. Сбор информации</strong><br>
        В настоящее время платформа не требует аутентификации пользователя или создания учетной записи. Никакая личная информация (например, имена или адреса электронной почты) не собирается от посетителей.<br><br>

        Х5Х2. Данные об использовании</strong><br>
        Базовая анонимная аналитика может быть собрана для анализа трафика сайта и улучшения приложений. Эти данные не связаны с личными данными отдельных пользователей.<br><br>

        Х10Х3. Сторонние услуги</strong><br>
        Сторонние поставщики могут использоваться для предоставления услуг хостинга и аналитики. Политика конфиденциальности этих поставщиков регулирует анонимные данные, обрабатываемые в их инфраструктуре.<br><br>

        Х15Х4. Безопасность данных</strong><br>
        Для защиты платформы принимаются разумные меры безопасности. Однако ни один метод передачи данных через Интернет не является полностью безопасным.<br><br>
    `,
    cookies_content: `
        Х0Х1. Что такое файлы cookie и локальное хранилище?</strong><br>
        Файлы cookie и локальное хранилище браузера — это небольшие файлы данных, хранящиеся на устройстве для запоминания настроек конфигурации при каждом посещении.<br><br>

        Х5Х2. Цель использования</strong><br>
        LocalStorage браузера используется исключительно для сохранения настроек конфигурации, таких как: <br>.
        - Языковые настройки<br>
        - Конфигурация пользовательского интерфейса (например, настройки макета или темы)<br>
        - Временный кэш приложений<br><br>

        Х13Х3. Нет отслеживания</strong><br>
        Файлы cookie и локальное хранилище не используются в целях рекламы или стороннего отслеживания. Все сохраненные данные предназначены исключительно для основных функций платформы.<br><br>

        Х18Х4. Управление</strong><br>
        Данные браузера можно очистить в любое время через настройки браузера, при этом будут сброшены все локальные конфигурации.
    `,
    cookie_consent_text: "Мы используем базовые файлы cookie для обеспечения правильной работы веб-сайта, например, для поддержания активности вашего сеанса, сохранения ваших языковых предпочтений и других пользовательских настроек.",
    read_policy: "Прочтите политику использования файлов cookie",
    support_title: "Обратиться в службу поддержки",
    support_subject_label: "Предмет",
    support_message_label: "Сообщение",
    support_submit_button: "Отправить сообщение",
    support_hint: "Примечание. Откроется почтовое приложение по умолчанию для отправки сообщения.",
    support_success_msg: "Открытие почтового приложения...",
    support_error_msg: "Не удалось отправить сообщение. Пожалуйста, повторите попытку позже.",
    explorer_title: "Исследователь",
    history_title: "История",
    animation_title: "Анимация",
    config_title: "Конфигурация",
    tool_mouse: "Выбрать (Ctrl+M)",
    tool_brush: "Кисть (Ctrl+B)",
    tool_brush_mode: "Режим переключения (сплошной/прозрачный)",
    tool_eraser: "Ластик (Ctrl+E)",
    tool_brush_size: "Отрегулируйте размер кисти",
    tool_bucket: "Заполнить (Ctrl+F)",
    tool_eyedropper: "Пипетка",
    tool_grid: "Сетка (Ctrl+Shift+B)",
    tool_rotate: "Поворот (Ctrl+Shift+R)",
    tool_flip_h: "Перевернуть H (Ctrl+Shift+H)",
    tool_flip_v: "Перевернуть V (Ctrl+Shift+V)",
    tool_transpose: "Транспонировать (Ctrl+Shift+T)",
    label_width: "Ширина",
    label_height: "Высота",
    label_frames: "Количество кадров",
    label_animation: "Стиль анимации",
    label_background_color: "Цвет фона",
    label_interval: "Интервал",
    tool_anim_config: "Конфигурация анимации",
    label_new_width: "Новая ширина",
    label_new_height: "Новая высота",
    label_apply: "Применять",
    label_colors: "Цвета",
    label_size: "Размер",
    label_tolerance: "Толерантность",
    val_horizontal: "Горизонтальный",
    val_vertical: "Вертикальный",
    val_sequence: "Последовательность",
    val_bounce: "Подпрыгивать",
    val_random: "Случайный",
    val_solid: "Твердый",
    val_clear: "Прозрачный",
    action_add_sheet: "Новый лист",
    action_import: "Импорт",
    action_export: "Экспорт",
    action_sort_projects: "Сортировать",
    sort_date_old: "Сначала самый старый",
    sort_date_new: "Новейшие сначала",
    sort_name_az: "Имя (А–Я)",
    sort_name_za: "Имя (Я-А)",
    action_new_sprite: "Новый спрайт",
    action_new_project: "Новый проект",
    modal_save_all_title: "Сохранить все изменения",
    modal_save_all_desc: "Выберите ресурсы для сохранения:",
    modal_save_selected: "Сохранить выбранное",
    action_saved: "Сохранено",
    modal_create_sprite_title: "Создать новый спрайт",
    modal_create_project_title: "Создать новый проект",
    modal_add_sheet_title: "Добавить новый лист",
    modal_rename_sheet_title: "Переименовать лист",
    modal_rename_sprite_title: "Переименовать спрайт",
    modal_delete_sprite_title: "Удалить спрайт",
    modal_delete_project_title: "Удалить проект",
    modal_delete_sheet_title: "Удалить лист",
    placeholder_sprite_name: "Имя",
    placeholder_project_name: "Имя",
    placeholder_sheet_name: "Имя",
    placeholder_new_name: "Новое имя",
    action_create: "Создавать",
    action_add: "Добавлять",
    action_rename: "Переименовать",
    action_duplicate: "Дублировать",
    action_delete: "Удалить",
    action_cancel: "Отмена",
    confirm_delete_sprite: "Вы уверены, что хотите удалить этот спрайт?",
    confirm_delete_project: "Вы уверены, что хотите удалить этот проект? Все спрайты будут удалены.",
    confirm_delete_sheet: "Вы уверены, что хотите удалить этот лист?",
    err_select_sprite: "Пожалуйста, сначала выберите спрайт.",
    err_select_project: "Пожалуйста, сначала выберите проект.",
    err_name_empty: "Имя не может быть пустым.",
    err_sprite_exists: "Спрайт с таким именем уже существует.",
    err_project_exists: "Проект с таким названием уже существует.",
    err_no_content: "Нет контента для сохранения.",
    err_no_changes: "Нет изменений для сохранения.",
    err_delete_last_sheet: "Невозможно удалить последний лист.",
    err_extract_frames: "Не удалось извлечь ни одного кадра.",
    err_indexeddb: "Не удалось сохранить локально. Ваш браузер может не поддерживать IndexedDB.",
    msg_upload_success: "Загрузка прошла успешно: {0}",
    msg_upload_failed: "Загрузка не удалась: {0}",
    msg_save_success: "Сохранение успешно.",
    msg_saving: "Сохранение...",
    msg_multi_save_result: "Сохранено {0} объектов. {1} отказов.",
    menu_title: "Меню",
    menu_save: "Сохранять",
    menu_save_all: "Сохранить все",
    menu_support: "Обратиться в службу поддержки",
    label_local_storage: "Локальное хранилище",
    label_sign_in: "Войти",
    modal_export_title: "Экспортировать спрайт",
    label_filename: "Имя файла",
    label_format: "Формат",
    action_export_confirm: "Экспорт",
};

export default translations;
